import React from "react";
import { Grid, Typography, TextField, Autocomplete, FormControl, InputLabel, Select, MenuItem, ListSubheader, Button } from "@mui/material";
import { bowelPrepMedications, nurseGroups } from "../constants/options";

const BowelPrepAndFileSection = ({ formData, handleChange, handleAutocompleteChange, handleNameChange, handleSignatureOpen }) => {
  return (
    <>
      <Typography variant="h6" sx={{ mt: 2 }}>
        Bowel Preparation
      </Typography>
      <Grid container spacing={6} >
        <Grid item xs={12} sm={6}>
          <TextField
            label="Time"
            type="time"
            InputLabelProps={{ shrink: true }}
            fullWidth
            name="bowel_preparation_time"
            value={formData.bowel_preparation_time || ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={bowelPrepMedications || []}
            inputValue={formData.bowel_preparation_medication || ""}
            onInputChange={(event, newInputValue) => handleAutocompleteChange("bowel_preparation_medication", newInputValue)}
            renderInput={(params) => (
              <TextField {...params} label="Medication" fullWidth />
            )}
          />
        </Grid>
      </Grid>

      <Typography variant="h6" sx={{ mt: 4 }}>
        File Completion
      </Typography>
      <Grid container spacing={6} >
        {[
          { label: "File Completed By Name of Nurse", key: "file_completed_signature", key1: "fild_completed_name" },
          { label: "File Checked By Name of Nurse", key: "charge_nurse_signature", key1: "fild_chaged_name" },
        ].map((person, index) => (
          <Grid item xs={12} sm={6} key={person.key}>
            <FormControl fullWidth sx={{ marginTop: 1 }}>
              <InputLabel id={`${person.key1}-label`}>Name ({person.label})</InputLabel>
              <Select
                labelId={`${person.key1}-label`}
                name={person.key1}
                value={formData[person.key1] || ""}
                label={`Name (${person.label})`}
                onChange={handleNameChange}
                required
              >
                <MenuItem value="">
                  <em>Select Nurse</em>
                </MenuItem>
                {Object.entries(nurseGroups).map(([groupName, nurses]) => [
                  <ListSubheader key={groupName}>{groupName}</ListSubheader>,
                  nurses.map((nurse, idx) => (
                    <MenuItem key={`${groupName}-${idx}`} value={nurse}>
                      {nurse}
                    </MenuItem>
                  ))
                ])}
              </Select>
            </FormControl>
            <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen(person.key)}>
              Sign Here
            </Button>
            {formData[person.key] && (
              <img src={`data:image/png;base64,${formData[person.key]}`} alt="Signature" style={{ marginTop: 10, border: '1px solid black', width: '100%', height: '150px' }} />
            )}
          </Grid>
        ))}
      </Grid>

      <Typography variant="h6" sx={{ mt: 4 }}>
        OT Transfer Time
      </Typography>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Shifted to OT At"
            value={formData.shifted_to_ot_at || ''}
            InputLabelProps={{ shrink: true }}
            type="datetime-local"
            inputProps={{ min: new Date().toISOString().slice(0, 16) }}
            name="shifted_to_ot_at"
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel id="handed-over-by-label">Handed Over By</InputLabel>
            <Select
              labelId="handed-over-by-label"
              name="handed_over_by"
              value={formData.handed_over_by || ""}
              label="Handed Over By"
              onChange={handleNameChange}
              required
            >
              <MenuItem value=""><em>Select Nurse</em></MenuItem>
              {Object.entries(nurseGroups).map(([group, nurses]) => [
                <ListSubheader key={group}>{group}</ListSubheader>,
                nurses.map((nurse, idx) => (
                  <MenuItem key={`${group}-${idx}`} value={nurse}>{nurse}</MenuItem>
                )),
              ])}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Received in OT At"
            type="datetime-local"
            name="received_in_ot_at"
            InputLabelProps={{ shrink: true }}
            value={formData.received_in_ot_at || ''}
            onChange={handleChange}
            inputProps={{ min: new Date().toISOString().slice(0, 16) }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel id="taken-over-by-label">Taken Over By</InputLabel>
            <Select
              labelId="taken-over-by-label"
              name="taken_over_by"
              value={formData.taken_over_by || ""}
              label="Taken Over By"
              onChange={handleNameChange}
              required
            >
              <MenuItem value=""><em>Select Nurse</em></MenuItem>
              {Object.entries(nurseGroups).map(([group, nurses]) => [
                <ListSubheader key={group}>{group}</ListSubheader>,
                nurses.map((nurse, idx) => (
                  <MenuItem key={`${group}-${idx}`} value={nurse}>{nurse}</MenuItem>
                )),
              ])}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};

export default BowelPrepAndFileSection;
